import Vue from "vue";

import Cookies from "js-cookie";

import "normalize.css/normalize.css"; // a modern alternative to CSS resets
import Element from "element-ui";
import "./styles/element-variables.scss";
import "./styles/fontIcon/iconfont.css";

import "@/styles/index.scss"; // global css
import App from "./App";
import store from "./store";
import router from "./router";

import "./icons"; // icon
import "./permission"; // permission control
import "./utils/error-log"; // error log
import { dynamicHeight } from "@/utils/dynamicHeight";
import * as filters from "./filters"; // global filters
import less from "less";
import { isAuth } from "@/utils";

import selectOrRadio from "@/components/selectOrRadio";
import dataPicker from "@/components/dataPicker";
import moreSearch from "@/components/moreSearch";
import customDrage from "@/components/customDrage";
import myDialog from "@/components/myDialog";
import { isKeyName } from "@/utils/ids/index.js";
import preventReClick from "./store/preventReClick";
import echarts from "echarts";
import print from "vue-print-nb";

Vue.prototype.$echarts = echarts;
Vue.use(less);
Vue.use(selectOrRadio);
Vue.use(dataPicker);
Vue.use(moreSearch);
Vue.use(customDrage);
Vue.use(myDialog);
Vue.use(dynamicHeight);
Vue.use(print);
Vue.prototype.$bus = new Vue();

Vue.prototype.isAuth = isAuth;
Vue.prototype.isKeyName = isKeyName;

Vue.use(Element, {
  size: Cookies.get("size") || "small", // set element-ui default size
});

// register global utility filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
window.addEventListener("resize", dynamicHeight);
Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App, preventReClick),
});
